import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';

import { DisplayValueModule } from '../../seds-form-field/pipes/display-value/display-value.module';
import { ErrorReaderModule } from '../../seds-form-field/pipes/error-reader/error-reader.module';
import { SedsFormFieldCoreModule } from '../../seds-form-field/seds-form-field-core/seds-form-field-core.module';
import { SedsLoadersBarModule } from '../../seds-loaders';
import { SedsFormFieldAutocompleteComponent } from './seds-form-field-autocomplete.component';

@NgModule({
  declarations: [SedsFormFieldAutocompleteComponent],
  imports: [
    CommonModule,
    DisplayValueModule,
    ErrorReaderModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatIconModule,
    MatInputModule,
    SedsLoadersBarModule,
    SedsFormFieldCoreModule,
  ],
  exports: [SedsFormFieldAutocompleteComponent, MatInput],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SedsFormFieldAutocompleteModule {}
